import { jsx as _jsx } from "react/jsx-runtime";
import { getUserMenuItems } from "@apptypes/userMenuItems";
import { useAppInitialization } from "@hooks/useAppInitialization";
import { useMenuItemsLoader } from "@hooks/useMenuItemsLoader";
import { useNavigate } from "react-router-dom";
import BaseLayout from "./BaseLayout";
import CommonLayout from "./CommonLayout";
var UserLayout = function () {
    var handleLogout = useAppInitialization().handleLogout;
    var navigate = useNavigate();
    var menuItems = useMenuItemsLoader(getUserMenuItems(navigate));
    return (_jsx(BaseLayout, { handleLogout: handleLogout, children: _jsx(CommonLayout, { menuItems: menuItems }) }));
};
export default UserLayout;
